var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMusic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7876 11.1515H25.3331",
    stroke: "#257FFC",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3331 21.3333V5.33333H10.7876V23.2727",
    stroke: "#257FFC",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.39394 26.6666C9.26836 26.6666 10.7879 25.1471 10.7879 23.2727C10.7879 21.3983 9.26836 19.8788 7.39394 19.8788C5.51952 19.8788 4 21.3983 4 23.2727C4 25.1471 5.51952 26.6666 7.39394 26.6666Z",
    stroke: "#257FFC",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9394 24.7273C23.8138 24.7273 25.3333 23.2078 25.3333 21.3333C25.3333 19.4589 23.8138 17.9394 21.9394 17.9394C20.0649 17.9394 18.5454 19.4589 18.5454 21.3333C18.5454 23.2078 20.0649 24.7273 21.9394 24.7273Z",
    stroke: "#257FFC",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusic);
export default __webpack_public_path__ + "static/media/music.bb036564.svg";
export { ForwardRef as ReactComponent };